import React from 'react';
import ReactDOM from 'react-dom';
import './style/index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
// redux Store
import { Provider } from 'react-redux';
import { createStore, combineReducers } from 'redux';
// reducers
import authReducer from './store/Reducer/authReducer';
import navigationReducer from './store/Reducer/navigationReducer';
import langReducer from './store/Reducer/langReducer';
import imageReducer from './store/Reducer/ImagesReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  navigation: navigationReducer,
  lang: langReducer,
  image: imageReducer,
});
const store = createStore(rootReducer);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.register();
